// Clinic Configuration for 
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in New Britain",
  clinicId: "dentistinnewbritain",
  clinicUrl: "https://dentistinnewbritain.com",
  // Contact Information
  phoneNumber: "860-259-4141",
  phoneNumberRaw: "+18602594141", // For tel: and sms: links
  email: "dentalcare@dentistinnewbritain.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinnewbritain&agentId=5cb083dd-5e42-4026-9ea1-28b8dc0890c0",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinnewbritain/voice",

  // Location
  address: "446 S Main St, New Britain CT 06051-3516, USA",
  addressShort: "446 S Main St, New Britain CT 06051-3516",
  city: "New Britain",
  hcity: "New-Britain",
  state: "Connecticut",
  stateShortForm: "CT",
  PostalCode: "06051",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/1PkAPoMpZ8ZSGJ1DA",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d145330.27510899285!2d-72.774474!3d41.65285!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e7b32159f53bd3%3A0x7dd6b32b245820cb!2sDentist%20in%20New%20Britain!5e1!3m2!1sen!2sin!4v1759924280337!5m2!1sen!2sin',
  iframeTitle: "Dentist in New Britain",

  //membership
  membership: "https://member.kleer.com/?slug=UU4R",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalPartners-DentistinNewBritain",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-new-britain?utm_source=practice&utm_medium=email&m=65963",


  // Analytics
  clarityProjectId: "prdkd0ahi0",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinnewbritain",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinnewbritain",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinnewbritain",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61566842104742#",
    instagram: "https://www.instagram.com/dentistinnewbritain_/",
    twitter: "https://x.com/dent_newbritain",
    linkedin: "https://www.linkedin.com/company/107868956/admin/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BZHzZHS4UQLaEyel%2BGoze8g%3D%3D",
    youtube: "https://www.youtube.com/@DentistinNewBritain",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 14,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 22,
      AppointmentTypeNum: 5
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 14,
      AppointmentTypeNum: 3
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 14,
      AppointmentTypeNum: 16
    }
  ],


  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;  
